import React, { Component, PropTypes } from 'react';
import _, {find, get} from 'lodash';
import { connect } from 'react-redux';

import TextField from '../../../../../common/components/c_TextField';
import TextArea from '../../../../../common/components/c_TextArea';
import DropDownMenu from '../../../../../common/components/c_DropDownMenu';
import DateInput from '../../../../../common/components/DateInput';
import CheckList from '../../../../../common/components/c_CheckList';
import { referralsByRole } from '../../../../../lib/staticData';
import {getSegmentsPositionsDepartments} from '../../../../../common/staticData/SegmentsPositionsDepartments';

const dropDownCustomization = {
  labelStyle: {
    padding: 0,
    margin: 0,
    maxWidth: '90%'
  },
  underlineStyle: {
    marginLeft: 0
  },
  containerStyle: {
    width: 'calc(50% - 35px)',
    margin: '30px 0 10px 45px'
  },
  floatingLabelStyle: {
    left: 0,
    top: '-10px'
  }
};

const secondDropDown = _.merge({}, dropDownCustomization, {
  containerStyle: {
    margin: '30px 0 10px 10px'
  }
});

// eslint-disable-next-line no-unused-vars
const textFieldStyle = {
  margin: '-8px 0 2px',
  width: '100%'
};

@connect(store => {
  return {
    labels: get(store, 'labels.PrelimInterview', {})
  };
})
export default class PrelimInterview extends Component {

  static propTypes = {
    staticData: PropTypes.object,
    applicant: PropTypes.object,
    script: PropTypes.bool,
    tempState: PropTypes.object,
    model: PropTypes.string.isRequired,
    updateTempState: PropTypes.func,
    labels: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      currentJobTitle: '',
    };
    this.yearsExperienceList = _.times(35, (i) => i + 1);
  }


  handleChangeIndustry() {
    return (event, value) => {
      return this.props.updateTempState(this.props.model, 'industryTypes', event, value);
    };
  }

  render() {

  const currentWorkFromHomeReasons = _.get(this.props.tempState, 'profile.workFromHomeReasons') || this.props.applicant.profile.workFromHomeReasons;
  const otherId = (this.props.staticData.applicantWorkFromHomeReasonsList.find(t => t.name === 'Other, Please Specify') || {}).id;
  const showOther = (currentWorkFromHomeReasons||[]).includes(otherId);
  const script = this.props.script;
  const isEmployed = this.props.applicant.profile.employmentStatus.name === 'Phasing into Retirement' || this.props.applicant.profile.employmentStatus.name === 'Employed';
  const isFullTime = (_.get(this.props.tempState, 'profile.currentWorkStatus.id') || this.props.applicant.profile.currentWorkStatus) === 1;
  const foundUsVia = referralsByRole(this.props.staticData.foundUsViaList);

  const workedLastIndustryList = [
    {value:'5 or less years ago', primaryText:'Yes'},
    {value:'More than 5 years ago', primaryText:'No'}
  ];

  const totalYearsExperienceList = this.props.staticData.applicantTotalYearsExperience.map((i) => i.text);
  const selectedIndustries = _.get(this.props.tempState, 'profile.industryTypes') || _.get(this.props, 'applicant.profile.industries').map((x) => x.id) || [];
  const otherIndustryTypeId = get(find(this.props.staticData.industryTypesList, {subElement: 'Other'}), 'id');
  const showOtherIndustry = selectedIndustries.includes(otherIndustryTypeId);

      // handles tempState updates
  function onChange(property, event, value, name) {
    if (property==='totalYearsExperienceNumeric' || property==='industryYearsExperienceNumeric') {
      if (!value) {
        if (event.target.value!==value) {
          value = event.target.value;
        }
      }
    }

    if(showOther && property === 'workFromHomeReason' && value !== otherId) {
      this.props.updateTempState(this.props.model, 'workFromHomeReasonOther', event, '');
    }

    if(showOtherIndustry && property === 'insuranceTypeOther' && value !== otherIndustryTypeId) {
        this.props.updateTempState(this.props.model, 'insuranceTypeOther', event, '');
    }

    // handle dropdown not check list
    if(!_.isArray(value) && name) {
      value = {
        id: value,
        name
      };
    }

    if(this.props.applicant.profile[property] !== value) { // add to tempstate
      this.props.updateTempState(this.props.model, property, event, value);
    } else if(_(this.props.tempState).omit(property).size()) { // remove from tempState if there remains properties on tempState without it
      this.props.updateTempState(this.props.model, property, event, value);
    } else { // wipe tempstate if this was only property
      this.props.updateTempState(null, null, null, null);
    }
  }
  const {segments, positions, departments} = getSegmentsPositionsDepartments(this.props);
  return (
    <div className='expanded-accordion-content prelim-interview'
      key={`prelim-interview ${this.props.applicant.profile.id}`}>
      {
        script
        &&
        <div>
          <div className='speaking-callout'>
            {this.props.labels.speakingCallout}
          </div>
        </div>
      }
      <DropDownMenu floatingLabelText='Employment status'
                    data-id='employmentStatus'
                    className='employment-status-dropdown'
                    value={this.props.applicant.profile.employmentStatus.id}
                    menuItems={this.props.staticData.employmentStatusList}
                    onChange={onChange.bind(this, 'employmentStatus')}
                    {...dropDownCustomization}/>
      {
        isEmployed
        &&
        <DropDownMenu floatingLabelText='Are you working full-time or part time now?'
                      data-id='currentWorkStatus'
                      className='work-status-dropdown'
                      value={this.props.applicant.profile.currentWorkStatus}
                      menuItems={this.props.staticData.currentEmploymentStatusList}
                      onChange={onChange.bind(this, 'currentWorkStatus')}
                      {...secondDropDown}/>
      }
      {
        isFullTime && script
        &&
        <div className='speaking-callout'>
          If working full-time, explain: All our jobs require that you are available during regular working hours for at least part of the time. You cannot work full-time and also work for WAHVE.
        </div>
      }
      <DateInput data-id='availabilityDate'
                 className='availability-date dropdown-wrapper'
                 floatingLabelText='Date available to start work'
                 container={'block'}
                 autoOk
                 minDate={new Date()}
                 defaultValue={_.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate}
                 value={_.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate}
                 onChange={onChange.bind(this, 'availabilityDate')}
                  />
      <div>

        <DropDownMenu floatingLabelText={this.props.labels.totalYearsExperience}
                    data-id='totalYearsExperience'
                    className='industry-drop-down'
                    value={_.get(this.props.tempState, 'profile.totalYearsExperienceNumeric', null) ? this.props.tempState.profile.totalYearsExperienceNumeric : this.props.applicant.profile.totalYearsExperienceNumeric}
                    menuItems={this.yearsExperienceList}
                    onChange={onChange.bind(this, 'totalYearsExperienceNumeric')}
                    {...dropDownCustomization}/>

        <DropDownMenu floatingLabelText={this.props.labels.industryYearsExperience}
                    data-id='industryYearsExperience'
                    className='industry-drop-down'
                    value={_.get(this.props.tempState, 'profile.industryYearsExperienceNumeric', null) ? this.props.tempState.profile.industryYearsExperienceNumeric : this.props.applicant.profile.industryYearsExperienceNumeric}
                    menuItems={this.yearsExperienceList}
                    onChange={onChange.bind(this, 'industryYearsExperienceNumeric')}
                    {...secondDropDown}/>

        <DropDownMenu floatingLabelText={this.props.labels.workedLastInIndustryYesNo}
                    data-id='workedLastInIndustry'
                    className='industry-drop-down'
                    value={this.props.applicant.profile.workedLastInIndustry}
                    menuItems={workedLastIndustryList}
                    onChange={onChange.bind(this, 'workedLastInIndustry')}
                    {...dropDownCustomization}/>
        <CheckList
          className='industry-drop-down'
          floatingLabelText={this.props.labels.industries}
          menuItems={this.props.staticData.industryTypesList}
          defaultValue={selectedIndustries}
          onBlur={this.handleChangeIndustry()}
        />
        {
          showOtherIndustry
          &&
          <TextField
            data-id='insuranceTypeOther'
            className='work-from-home-reasons'
            style={{marginLeft: '100px'}}
            defaultValue={this.state.insuranceTypeOther || this.props.applicant.profile.insuranceTypeOther}
            onChange={(event, val) => { this.setState({ insuranceTypeOther: val}); }}
            onBlur={onChange.bind(this, 'insuranceTypeOther')}
            floatingLabelText='Please Specify Other Firm Type' />
        }
      </div>

      {
        this.props.staticData.account.hardcodelink !== 'WAHVE' &&
          <TextField
          defaultValue={_.get(this.state, 'currentJobTitle') || this.props.applicant.profile.currentJobTitle}
          floatingLabelText={this.props.labels.currentJobTitle}
          className='current-job-title'
          data-id={this.props.labels.currentJobTitle}
          style={_.merge({}, textFieldStyle, {padding: '20px 28px 20px 45px'})}
          onChange={(event, val) => { this.setState({ currentJobTitle: val}); }}
          onBlur={onChange.bind(this, 'currentJobTitle', event, this.state.currentJobTitle, null)}
          />
      }

      {
      this.props.staticData.account.hardcodelink === 'WAHVE' &&
          <DropDownMenu
            floatingLabelText={this.props.labels.mostRecentSegment}
            style={{width: 350}}
            data-id='mostRecentSegment'
            value={this.props.applicant.profile.mostRecentSegment}
            menuItems={segments}
            onChange={onChange.bind(this, 'mostRecentSegment')}
            {...dropDownCustomization}
          />
      }

      {
        this.props.staticData.account.hardcodelink === 'WAHVE' &&
        <DropDownMenu
          floatingLabelText={this.props.labels.mostRecentDepartment}
          style={{width: 350}}
          data-id='mostRecentDepartment'
          value={this.props.applicant.profile.mostRecentDepartment}
          menuItems={departments}
          onChange={onChange.bind(this, 'mostRecentDepartment')}
          {...secondDropDown}/>
      }

      {
        this.props.staticData.account.hardcodelink === 'WAHVE' &&
            <DropDownMenu
              floatingLabelText={this.props.labels.mostRecentPosition}
              style={{width: 350}}
              data-id='mostRecentPosition'
              value={this.props.applicant.profile.mostRecentPosition}
              menuItems={positions}
              onChange={onChange.bind(this, 'mostRecentPosition')}
              {...dropDownCustomization}/>
      }

      <DropDownMenu floatingLabelText={this.props.labels.foundUsVia}
                    data-id='foundUsVia'
                    value={this.props.applicant.profile.foundUsVia.id}
                    menuItems={foundUsVia}
                    onChange={onChange.bind(this, 'foundUsVia')}
                    {...dropDownCustomization}
      >
        {{
          Other: <TextField floatingLabelText='Please Specify'
                            data-id='foundUsOther'
                            defaultValue={typeof this.props.tempState.foundUsOther === 'string' ? this.props.tempState.foundUsOther : this.props.applicant.profile.foundUsOther}
                            onBlur={onChange.bind(this, 'foundUsOther')}
          />
        }}
      </DropDownMenu>

      <div className='callout'>
        <b>Instructions:</b>  If the applicant did not enter accurate information and does not meet the requirements, you may need to disqualify the applicant at this point.
      </div>

      <div className='speaking-callout'>
        Reasons would like to work from home.
      </div>

      <CheckList className='work-from-home-reasons'
                 key={`${this.props.applicant.profile.id} workFromHomeReasons`}
                 data-id='workFromHomeReasons'
                 defaultValue={currentWorkFromHomeReasons}
                 onBlur={onChange.bind(this, 'workFromHomeReasons')}
                 menuItems={this.props.staticData.applicantWorkFromHomeReasonsList}/>
      {
        showOther
        &&
        <TextArea floatingLabelText='Please Specify'
          key={`${this.props.applicant.profile.id} Work From Home Reason Other`}
                   data-id='workFromHomeReasonOther'
                   defaultValue={typeof this.props.tempState.workFromHomeReasonOther === 'string' ? this.props.tempState.workFromHomeReasonOther : this.props.applicant.profile.workFromHomeReasonOther}
                   onBlur={onChange.bind(this, 'workFromHomeReasonOther')}
                   rootStyle={{
                     margin: '-9px 42px 9.5px',
                     width: 'calc(50% - 35px)'
                   }}/>
      }
    </div>
  );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Profile/f_PrelimInterview/index.js